import { markRaw } from 'vue';
import { mapState } from 'vuex';
import { ContractChartGroup, ContractChartGroupStock } from '@/utils/chart-models';
import { applyChartTheme } from '@/utils/chart-theme';

export default {
  props: {
    chartData: {
      type: Array,
      required: true,
      default: null,
    },
    chartDataLoaded: {
      type: Boolean,
      default: false,
    },
    chartOptions: {
      type: Object,
      default: null,
    },
    market: {
      type: Object,
      required: true,
    },
    timeline: {
      type: String,
      required: false,
    },
    chartType: {
      type: String,
      required: false,
    },
    chartSystemOptions: {
      type: Object,
      default: () => {},
    },
    showVolume: {
      type: Boolean,
      default: false,
    },
    showPriceAxisZoom: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  computed: {
    ...mapState('app', ['resolvedTheme']),
    containerStyleModifiers() {
      let height = '390px';
      if (this.chartOptions && this.chartOptions.maxHeight) {
        height = this.chartOptions.maxHeight;
      }
      if (this.chartSystemOptions && this.chartSystemOptions.maxHeight) {
        height = this.chartSystemOptions.maxHeight;
      }
      return {
        height,
      };
    },
  },
  watch: {
    showVolume() {
      this.renderChart();
    },
    showPriceAxisZoom() {
      this.renderChart();
    },
    chartType() {
      this.renderChart();
    },
    chartData(value) {
      this.createChart(value);
    },
    resolvedTheme() {
      if (this.chart) this.renderChart();
    },
  },
  methods: {
    createChart(data) {
      if (data && data.length > 0) {
        setTimeout(() => {
          this.renderChart();
        }, ContractChartGroup.renderTimeout());
      } else if (this.$refs.chart) {
        this.$refs.chart.innerHTML = '';
      }
    },
    renderChart() {
      if (!this.$refs.chart) return;
      if (this.chart !== null) {
        this.chart.destroy();
      }
      const ClassName = this.chartType === 'candle' ? ContractChartGroupStock : ContractChartGroup;
      const options = this.chartOptions || {};
      options.showVolume = this.showVolume;
      options.showPriceAxisZoom = this.showPriceAxisZoom;
      const group = new ClassName({
        market: this.market,
        timeline: this.timeline,
        data: this.chartData,
        chartOptions: options,
      });
      this.chart = markRaw(group.draw(this.$refs.chart));
      applyChartTheme(this.chart);
    },
  },
  beforeUnmount() {
    this.chart?.destroy();
  },
};
